import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import {
    BANK_FINANCIAL_REVIEW_PROVIDER,
    ReviewModuleType,
} from './bank-financial-review.provider';

export const moduleTypeResolver: ResolveFn<ReviewModuleType> = async (route) => {
  const router = inject(Router);
  const queryModuleType = route.queryParamMap.get('moduleType');

  if (queryModuleType === 'BANK' || queryModuleType === 'NON_BANK') {
    return queryModuleType;
  }

  const navigationState = router.getCurrentNavigation()?.extras?.state;
  const stateModuleType = navigationState?.['moduleType'];

  if (stateModuleType === 'BANK' || stateModuleType === 'NON_BANK') {
    return stateModuleType;
  }

  const provider = inject(BANK_FINANCIAL_REVIEW_PROVIDER);
  const lenderId = route.paramMap.get('lenderId') ?? '';
  const financialPeriod = route.paramMap.get('financialPeriod') ?? '';

  if (!lenderId || !financialPeriod) {
    void router.navigate(['/financial-submissions'], {
      queryParams: { error: 'unconfigured-lender' },
    });
    return null;
  }

  try {
    const rows = await provider.getLandingRows(lenderId);
    const matched = rows.find((row) => row.financialPeriod === financialPeriod);
    const resolvedType = matched?.moduleType ?? null;

    if (resolvedType == null) {
      void router.navigate(['/financial-submissions'], {
        queryParams: { error: 'unconfigured-lender', lenderId },
      });
      return null;
    }

    return resolvedType;
  } catch {
    void router.navigate(['/financial-submissions'], {
      queryParams: { error: 'unconfigured-lender', lenderId },
    });
    return null;
  }
};
